import { isSchema } from "@cartographerio/topo-survey";
import { Result } from "@cartographerio/fp";
import { isSurveyModuleId, isSurveyNames, unsafeMapLayerId, } from "@cartographerio/types";
import { isObject } from "lodash-es";
import { SurveyModule } from "./module.js";
export function surveyModule(parts) {
    return new SurveyModule(parts);
}
export function surveyModuleFromJson(parts) {
    const { moduleJson, formSchema, dataDescription, dataGeometry, dataTimestamp, copyData, mapLinks, } = parts;
    return Result.guard(isObject, "object"
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    )(moduleJson).flatMap((json) => {
        const { moduleId, names, dataSchema } = json;
        return Result.tupled([
            Result.guard(isSurveyModuleId, "SurveyModuleId")(moduleId),
            Result.guard(isSurveyNames, "SurveyNames")(names),
            Result.guard(isSchema, "Schema")(dataSchema),
        ]).map(([moduleId, names, dataSchema]) => surveyModule({
            moduleId,
            names,
            dataSchema,
            formSchema,
            dataDescription,
            dataGeometry,
            dataTimestamp,
            copyData,
            mapLinks,
        }));
    });
}
export function mapLink(opts) {
    const { label, mapId, layerId = unsafeMapLayerId(mapId), attributeId = "surveyId", } = opts;
    return { label, mapId, layerId, attributeId };
}
//# sourceMappingURL=create.js.map